import { ReactNode } from "react";

export interface IDropdown {
  className?: string;
  children: ReactNode;
}

function Dropdown({ className, children }: IDropdown) {
  return <li className={className}>{children}</li>;
}
export default Dropdown;
